import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import * as actions from '../../actions'
import { connect } from 'react-redux'

function OperacionesAsignacion (props) {
  function onClick () {
    const { tableMeta } = props
    console.log('rowData', tableMeta)
    props.eliminarAsignacionCache(tableMeta.rowData)
  }
  return (
    <div>
      <Tooltip title={'Eliminar Asignacíon'}>
        <IconButton onClick={onClick}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesAsignacion)
